import { ImageObject } from "@/modules/images";

const images: ImageObject = {};

export default images;
